import React from 'react';
import { Box, IconButton, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import { SOURCE_LIST_MAX_HEIGHT } from '../constants';
import { formatDisplayUrl } from '../utils';
import SharedToggleButton from './SharedToggleButton';
import SourceProcessingStatus from './SourceProcessingStatus';
import SourceFailureNotice from './SourceFailureNotice';
import { isSourceFailed } from './sourceStatus';

const UrlList = ({
  urls = [],
  onRemove,
  removingId,
  showSharing = false,
  onToggleSharing,
  sharingId,
  onRetry,
  retryingId,
}) => {
  if (!urls.length) return null;

  return (
    <Box
      sx={{
        maxHeight: SOURCE_LIST_MAX_HEIGHT,
        overflowY: 'auto',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
      }}
    >
      {urls.map((item) => (
        <Box
          key={item._id}
          px={1.25}
          py={1}
          borderBottom='1px solid'
          borderColor='divider'
          sx={{ '&:last-child': { borderBottom: 'none' } }}
        >
          <Box display='flex' alignItems='center' gap={1}>
            <LinkOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary', flexShrink: 0 }} />
            <Box minWidth={0} flex={1}>
              <Link
                href={item.url}
                target='_blank'
                rel='noopener noreferrer'
                underline='hover'
                variant='body2'
                noWrap
                title={item.url}
                sx={{ display: 'block' }}
              >
                {formatDisplayUrl(item.url)}
              </Link>
              <SourceProcessingStatus source={item} />
            </Box>
            {showSharing && (
              <SharedToggleButton
                shared={!!item.sharedWithLeadAgents}
                disabled={sharingId === item._id}
                onToggle={() => onToggleSharing?.(item)}
              />
            )}
            {onRemove && (
            <IconButton
              size='small'
              aria-label={`Remove ${item.url}`}
              disabled={removingId === item._id}
              onClick={() => onRemove(item)}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
            )}
          </Box>

          {isSourceFailed(item) && (
            <SourceFailureNotice
              source={item}
              onRetry={onRetry}
              isRetrying={retryingId === item._id}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default UrlList;
